import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetActiveExtraCall} from '../../apis/extra';
import {SET_ACTIVE_EXTRA} from '../../constants/ExtraConstants';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';

function* tryFunction() {
    const response: number[] = yield call(GetActiveExtraCall);
    yield put({type: SET_ACTIVE_EXTRA, payload: response});
}

export function* getActiveExtraSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GENERIC_ERROR,
    };
    yield call(skeletonSaga, sagaPayload);
}
